import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac39df96"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
import { ref, onMounted, onBeforeUnmount } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        room: null
    },
    setup(__props) {
        const props = __props;
        const wrapper = ref(null);
        const iframe = ref(null);
        // Natural iframe size
        const IFRAME_WIDTH = 1920;
        const IFRAME_HEIGHT = 1080;
        function updateScale() {
            if (!wrapper.value || !iframe.value)
                return;
            const { clientWidth, clientHeight } = wrapper.value;
            const scaleX = clientWidth / IFRAME_WIDTH;
            const scaleY = clientHeight / IFRAME_HEIGHT;
            const scale = Math.min(scaleX, scaleY); // fit inside wrapper
            // Apply scaling
            iframe.value.style.transform = `scale(${scale})`;
            iframe.value.style.transformOrigin = 'top left';
            // Center iframe inside wrapper
            const offsetX = (clientWidth - IFRAME_WIDTH * scale) / 2;
            const offsetY = (clientHeight - IFRAME_HEIGHT * scale) / 2;
            iframe.value.style.position = 'absolute';
            iframe.value.style.left = `${offsetX}px`;
            iframe.value.style.top = `${offsetY}px`;
            // Keep natural size for scaling
            iframe.value.style.width = `${IFRAME_WIDTH}px`;
            iframe.value.style.height = `${IFRAME_HEIGHT}px`;
        }
        onMounted(() => {
            updateScale();
            window.addEventListener('resize', updateScale);
        });
        onBeforeUnmount(() => {
            window.removeEventListener('resize', updateScale);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref: (_value, _refs) => {
                    _refs['wrapper'] = _value;
                    wrapper.value = _value;
                },
                class: "iframe-wrapper"
            }, [
                _createElementVNode("iframe", {
                    ref: (_value, _refs) => {
                        _refs['iframe'] = _value;
                        iframe.value = _value;
                    },
                    src: '/room/' + props.room._id
                }, null, 8, _hoisted_1)
            ], 512));
        };
    }
});
